import { useCreation } from 'ahooks';
import { Divider, Space } from 'antd';
import PlatformTag from 'components/PlatformTag';
import React, { memo } from 'react';
import { useTranslate } from '@tolgee/react';
import groupByTs from 'utils/groupByTs';
import { useDepartmentDetailOfId } from './hooks/data';

interface Department extends StoreHomeV2.Department {}

export interface DepartmentStoreScopeStatsProps {
  departmentId?: Department['id'];
}

const DepartmentStoreScopeStats = (props: DepartmentStoreScopeStatsProps) => {
  const { departmentId } = props;
  const { t } = useTranslate();
  const { data } = useDepartmentDetailOfId(departmentId);

  return useCreation(() => {
    const platformStats = groupByTs(data?.platformStoreScopes || [], 'platform');
    const sum = (scopes: General.StoreScope[] = []) => {
      return scopes.reduce((sum, t) => sum + (t.storeCount || 0), 0);
    };
    const filterPlatforms = Object.keys(platformStats).filter(
      (p) => p !== 'ALIEXPRESS' && p !== 'WA',
    );
    const sums: Record<string, number> = {};
    filterPlatforms.forEach((platform) => {
      sums[platform] = sum(platformStats[platform]);
    });
    return (
      <div className="flex">
        <div>{t('department.负责店铺')}：</div>
        <div className="flex-1">
          <Space size={1} wrap>
            {Object.keys(sums).reduce((nodes, platform) => {
              const count = sums[platform];
              if (!count) {
                return nodes;
              }
              const noDivider = nodes.length < 1;
              nodes.push(
                <div key={`DepartmentStoreScopeStats_${platform}`} className="mb-1">
                  {noDivider ? null : <Divider type="vertical" />}
                  <PlatformTag platform={platform as General.PlatformUpperCase} />
                  {t('feedback.全部')}({count})
                </div>,
              );
              return nodes;
            }, [] as React.ReactNode[])}
          </Space>
        </div>
      </div>
    );
  }, [data, t]);
};
export default memo(DepartmentStoreScopeStats);
